import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { FormField } from 'ui/formField';
import { RadioList } from 'ui/radioList';
import { InputText } from 'ui/inputs/inputText';
import { BasicSelect } from 'ui/selects';
import { RETENTION_PERIOD_RADIO_OPTIONS, RETENTION_PERIOD_SELECT_OPTIONS } from '../constants';
import { RetentionPeriodFormData } from '../types';

const StyledRadioList = styled(RadioList)`
  margin-top: ${spacing.base};
`;

// use && to increase CSS specificity to override default styles
const StyledFormField = styled(FormField)`
  && {
    padding-left: ${spacing.plusHalf};
    margin-top: 0;
  }
`;

const StyledRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const FORM_TEXT = {
  DESCRIPTION_TEXT: `Event instances that fall outside of the retention period will automatically be scheduled for deletion and can't be recovered.`,
  LABEL_TEXT: 'Retention period',
  RADIO_LIST_PREFIX: 'radio-list',
  INPUT_PREFIX: 'duration',
  SELECT_PREFIX: 'duration-type',
};

type Props = {
  error: string;
  formData: RetentionPeriodFormData;
  id: string;
  setFormData: (key: string, value: string) => void;
};

export const RetentionPeriodForm = ({ error, formData, id, setFormData }: Props) => (
  <>
    <FormField labelText={FORM_TEXT.LABEL_TEXT} descriptionText={FORM_TEXT.DESCRIPTION_TEXT}>
      <StyledRadioList
        name={`${FORM_TEXT.RADIO_LIST_PREFIX}-${id}`}
        options={RETENTION_PERIOD_RADIO_OPTIONS}
        onSelect={(value) => setFormData('radio', value)}
        value={formData.radio}
      />
    </FormField>
    {formData?.radio === '999999' && (
      <StyledFormField errorText={error} hasError={!!error} inputId={`input-${id}`}>
        <StyledRow>
          <InputText
            hasError={!!error}
            id={`${FORM_TEXT.INPUT_PREFIX}-${id}`}
            minValue={1}
            type="number"
            value={formData?.input}
            onChange={(value) => setFormData('input', value)}
          />
          <BasicSelect
            id={`${FORM_TEXT.SELECT_PREFIX}-${id}`}
            defaultValues={[formData?.select]}
            onSelect={([value]) => setFormData('select', value)}
            options={RETENTION_PERIOD_SELECT_OPTIONS}
          />
        </StyledRow>
      </StyledFormField>
    )}
  </>
);
